module.exports = __webpack_public_path__ + "img/get-free-insurance-quote-page-bottom.531740f6.svg";